export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14013.67678387.jpg";